var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-card", { staticClass: "step__" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", { staticClass: "line" }),
              _c("span", [_vm._v("第一步：选择模板")]),
            ]),
          ]
        ),
        _c(
          "div",
          [
            _c(
              "el-input",
              {
                attrs: { placeholder: "搜索GRI编码或名称", clearable: "" },
                on: { clear: _vm.getTemplateList },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getTemplateList.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.griCode,
                  callback: function ($$v) {
                    _vm.griCode = $$v
                  },
                  expression: "griCode",
                },
              },
              [
                _c("i", {
                  staticClass: "el-input__icon el-icon-search",
                  attrs: { slot: "prefix" },
                  slot: "prefix",
                }),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "10px",
              display: "flex",
              "flex-wrap": "wrap",
              "max-height": "550px",
              overflow: "auto",
            },
          },
          _vm._l(_vm.itemList, function (item) {
            return _c(
              "div",
              {
                staticClass: "list__item",
                class: { selected: item.tplId === _vm.selectedTemplate.tplId },
                on: {
                  click: function ($event) {
                    return _vm.selectItem(item)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "flex-start",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "min-width": "50px",
                          "text-align": "center",
                          background: "#ECF2FF",
                          border: "1px solid #D9E6FF",
                          "font-size": "12px",
                          color: "#408EFF",
                          padding: "1px 5px",
                          "border-radius": "5px",
                        },
                      },
                      [_vm._v(_vm._s(item.griCode))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          color: "#303133",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(item.griName))]
                    ),
                  ]
                ),
                _c("div", { staticStyle: { "margin-top": "15px" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticStyle: { color: "#909399" } }, [
                        _vm._v("Category2:"),
                      ]),
                      _c("div", { staticStyle: { color: "#606266" } }, [
                        _vm._v(_vm._s(item.category2Name)),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticStyle: { color: "#909399" } }, [
                        _vm._v("Category3:"),
                      ]),
                      _c("div", { staticStyle: { color: "#606266" } }, [
                        _vm._v(_vm._s(item.category3Name)),
                      ]),
                    ]
                  ),
                ]),
                _c("el-divider"),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "font-size": "12px",
                      color: "#909399",
                    },
                  },
                  [
                    _c("div", [_vm._v(_vm._s(item.processCount) + " 个制成")]),
                    _c("div", [_vm._v(_vm._s(item.paramCount) + " 个参数")]),
                  ]
                ),
                _c("el-divider"),
                _c(
                  "div",
                  { staticStyle: { "font-size": "12px", color: "#A9AEB8" } },
                  [_vm._v(_vm._s(item.comments))]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("el-card", { staticClass: "step__" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", { staticClass: "line" }),
              _c("span", [_vm._v("第二步：下载模板")]),
            ]),
          ]
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: !_vm.selectedTemplate.tplId,
                },
                on: { click: _vm.downloadTemplate },
              },
              [_vm._v("下载模板")]
            ),
            _c(
              "span",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "12px",
                  color: "red",
                },
              },
              [_vm._v("请先选择模板")]
            ),
          ],
          1
        ),
      ]),
      _c("el-card", { staticClass: "step__" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", { staticClass: "line" }),
              _c("span", [_vm._v("第三步：上传文件")]),
            ]),
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center" } },
          [
            !_vm.currentFileName
              ? _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticClass: "upload-demo",
                    class: { upload__disabled: !_vm.selectedTemplate.tplId },
                    attrs: {
                      drag: "",
                      action: "",
                      headers: _vm.uploadHeader,
                      "show-file-list": false,
                      "http-request": _vm.customUpload,
                      "before-upload": _vm.beforeUpload,
                      disabled: !_vm.selectedTemplate.tplId,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v("将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      },
                      [_vm._v("只能上传xlsx/xls文件，且不超过10MB")]
                    ),
                    _c("div", { attrs: { slot: "tip" }, slot: "tip" }, [
                      _vm.currentFileName
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-bottom": "5px",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.currentFileName) + " ")]
                          )
                        : _vm._e(),
                      _vm.showErrorDownload &&
                      _vm.errorMsgList &&
                      _vm.errorMsgList.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "a-link",
                              staticStyle: { "font-size": "12px" },
                              on: { click: _vm.downloadErrorMessage },
                            },
                            [_vm._v("导入错误信息.txt")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.currentFileName
              ? _c(
                  "el-upload",
                  {
                    ref: "uploadRef",
                    staticClass: "upload-demo",
                    class: { upload__disabled: !_vm.selectedTemplate.tplId },
                    attrs: {
                      action: "",
                      headers: _vm.uploadHeader,
                      "show-file-list": false,
                      "http-request": _vm.customUpload,
                      "before-upload": _vm.beforeUpload,
                      disabled: !_vm.selectedTemplate.tplId,
                    },
                  },
                  [
                    _c("div", { attrs: { slot: "tip" }, slot: "tip" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("div", { staticStyle: { "max-width": "50%" } }, [
                            _vm._v(_vm._s(_vm.currentFileName)),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "30px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.doUpload },
                                },
                                [_vm._v("重新上传")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "mini", type: "danger" },
                                  on: { click: _vm.doDelete },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.showErrorDownload &&
                      _vm.errorMsgList &&
                      _vm.errorMsgList.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "a-link",
                              staticStyle: {
                                "font-size": "12px",
                                "margin-top": "15px",
                              },
                              on: { click: _vm.downloadErrorMessage },
                            },
                            [_vm._v("导入错误信息.txt")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("el-divider"),
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "flex-end" } },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.cancelImport },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: {
                size: "mini",
                type: "primary",
                disabled: !_vm.showErrorDownload,
              },
              on: { click: _vm.confirmImport },
            },
            [_vm._v("确认导入")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }